/* homemodule */
/* globalmodule */
define( '../src/sublayouts/m17-sectiontitle/m17-sectiontitle',[ 'jquery' ], function ( $ ) {

	'use strict';

	var M17_SECTIONTITLE = function ($component) {

		this.$component = $component;

		return this;
	};

	/**
	 * Initialise component
	 */

	M17_SECTIONTITLE.prototype.init = function () {
		
    this.$rammasTrigger = this.$component.find('.m17-sectiontitle-rammas__trigger');
   	this.$rammasTrigger.on('click',function(event) { 
    	event.preventDefault();
    	this.$rammasBtn = $('.rammas-wrapper').find('a');
        this.$rammasBtn.trigger( "click" );
   		})
    };

	return M17_SECTIONTITLE;
});
